import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useFormContext } from 'react-hook-form';
import type { Option, SelectProps } from 'components/common';
import Select from '../../../components/common/Select';
import { useAccounts } from '../api/getAccounts';
import type { FC } from 'react';
import type { ResultEntry } from 'types/shared';

type AdAccountSelectProps = Pick<SelectProps, 'handleChange'>

export const AdAccountSelect = ({ handleChange }: AdAccountSelectProps) => {
  const { watch } = useFormContext();
  const app = watch('app');

  const { data, isLoading } = useAccounts<Option[]>({
    params: { app, platform: 'WEB' },
    config: {
      enabled: !!app,
      select: (data) =>
        data.map((item) => ({
          value: item.account_id,
          label: item.name,
        })),
    },
  });
  return isLoading ? (
    <Skeleton
      height={40}
      sx={{ transform: 'translateY(0)', borderRadius: '8px', width: '100%' }}
    />
  ) : (
    <Select
      name="accountId"
      inputLabel="Ad Account"
      disabled={isEmpty(data)}
      options={data ?? []}
      handleChange={handleChange}
    />
  );
};

export const JobResultTable: FC<{ rows?: ResultEntry[] }> = ({ rows }) => {
  return (
    <TableContainer sx={{ width: '100%' }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 220 }}>Account Ad ID</TableCell>
            <TableCell align="center" sx={{ minWidth: 120 }}>
              AdGroup
            </TableCell>
            <TableCell align="center">Creative</TableCell>
            <TableCell align="center" sx={{ minWidth: 120 }}>
              Result
            </TableCell>
            <TableCell align="center" sx={{ minWidth: 120 }}>
              Ad ID
            </TableCell>
            <TableCell align="center">Message</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row, i) => (
            <TableRow
              key={`${i}:${row.name}`}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.advertiser_id}
                </Typography>
              </TableCell>
              <TableCell align="left">
                {' '}
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.adgroup_name}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.creative_name}
                </Typography>
              </TableCell>
              <TableCell align="center">
                {row.is_successful ? '✅' : '❌'}
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.ad_id}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <Typography
                  sx={{
                    fontSize: 14,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                  }}
                >
                  {row.message}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
